import React, {Component} from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import {Button, Card, Form, notification, Popconfirm, Tabs, Tooltip} from 'antd'
import {TableComp, FormUtils as GetAllFormFields} from 'sz-react-utils'
import Request from '../../../request'
import styles from '../../Template/all/styles.less'
import moment from 'moment'
import _ from 'lodash'

import {RightsWrapper} from '../../../components/_utils/utils'
const TabPane = Tabs.TabPane

@Form.create()

class AllPlans extends Component {
  state = {
    id: '',
    total: 0,
    activeTab: '0',
    refreshChild: false
  }

  apiRequest = params => {
    return new Promise(async resolve => {
      params.agentType = "Branch"
      this.setState({exportParams: params})
      let data = await Request.getPlanDetails({
        ...params,
        regExFilters: []
      })
      this.setState({total: data.total})
      resolve(data)
    })
  }
  handleSubmit = e => {
    const {dispatch, form} = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let values = _.clone(valData)
        values.agentType = "Branch"
        let x = null
        if (this.state.id) {
          values._id = this.state.id
          x = await Request.updatePlanDetails(values)
        } else {
          x = await Request.addPlanDetails(values)
        }

        if (!x.error) {
          this.setState({
            id: '',
            activeTab: '0',
          })
          notification.success({
            message: this.state.id
              ? `Plan Detail Updated Successfully`
              : 'Plan Detail Added successfully'
          })
          if (!this.state.id) {
            form.resetFields()
          }
          if (this.table && this.table.current)
            this.table.current.reload()

        } else {
          notification.error({
            message: 'Error Saving',
            description: x.msg
          })
        }
      }
    })
  }
  deletePlanDetails = async data => {
    this.setState({loading: true})
    await Request.deletePlanDetails(data)

    this.setState({loading: false})

    this.table.current.reload()

    notification.success({
      message: 'Deleted Successfully',
      duration: 20,
      key: `${data._id}-close`
    })
  }
  callback = (value) => {
    if (value) {
      this.chooseTab(value)
    }
  }
  setPlanDetailsData(companyDetailId) {
    if (companyDetailId) {
      Request.planDetailsByID({id: companyDetailId}).then(
        ({doc, error, message}) => {
          if (!error && doc) {
            this.setState({
              id: doc._id,
              activeTab: '1'
            })
            
            this.props.form.setFieldsValue({
              agentType: doc.agentType,
              planName: doc.planName,
              planCommission: doc.planCommission,
              planCommissionType: doc.planCommissionType,
              planStatus: doc.planStatus
            })
          } else {
            notification.error({
              message: 'Error Getting Data',
              description: message
            })
          }
        }
      )
    }
  }
  refreshFxn = () => {
    this.setState({refreshChild: !this.state.refreshChild})
  }

  componentWillMount() {
    
  }

  async componentDidMount() {
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }
  chooseTab(value) {
    this.setState({
        activeTab: value
    })
  }
  render() {
    const {dispatch} = this.props
    const {
      form: {getFieldDecorator, setFieldsValue}
    } = this.props
    const {id} = this.state;

    const inputTypes = {
      fields: [
        // {
        //   label: "Agent Type",
        //   key: "agentType",
        //   required: true,
        //   type: "select",
        //   options: ["Branch", "Associate Partner"],
        //   onChange: (v) => {
        //     this.props.form.setFieldsValue({
        //       agentType: v,
        //     });
        //   },
        // },
        {
          label: 'Plan Name',
          key: 'planName',
          required: true
        },
        {
          label: 'Plan Commission',
          key: 'planCommission',
          required: true
        },
        {
          label: 'Plan Commission Type',
          key: 'planCommissionType',
          type: 'select',
          required: true,
          showSearch: true,
          disabled: false,
          options: [
            'Flat', 'Percentage'
          ],
          onChange: v => {
            this.props.form.setFieldsValue({
              planCommissionType: v
            })
          }
        },
        {
          label: 'Status',
          key: 'planStatus',
          type: 'select',
          required: true,
          showSearch: true,
          disabled: false,
          options: [
            'Active', 'Inactive'
          ],
          onChange: v => {
            this.props.form.setFieldsValue({
              planStatus: v
            })
          }
        }
      ]
    };

    const columns = [
      {
        title: 'Type',
        key: 'agentType',
      },
      {
        title: 'Plan Name',
        key: 'planName',
      },
      {
        title: 'Plan Commission',
        key: 'planCommission',
      },
      {
        title: 'Plan Commission Type',
        key: 'planCommissionType',
      },
      {
        title: 'Updated By',
        key: 'lastUpdatedByName',
        dataIndex: 'lastUpdatedByName',
        render: (text, record) => {
          return (
            <div>
              <div>{record.updatedByUser != null ? record.updatedByUser.name : record.createdByUser != null ? record.createdByUser.name : ""}</div>
              <small>{record.updatedByUser ? moment(record.updatedByUser.time).format('lll') : record.createdByUser ? moment(record.createdByUser.time).format('lll') : '' }</small>
            </div>
          )
        }
      },
      {
        title: 'Action',
        key: 'operation',
        render: (text, record) => (
          <React.Fragment>
            <RightsWrapper myRight={'plans.edit'}>
              <Tooltip title="Edit Plan">
                <Button
                  className={styles.btn}
                  shape="circle"
                  onClick={() => {
                    this.setPlanDetailsData(record._id)
                  }}
                  icon="edit"
                />
              </Tooltip>
            </RightsWrapper>
            <RightsWrapper myRight={'plans.delete'}>
              <Tooltip title="Delete Plan">
                <Popconfirm
                  title="Are you sure delete this PLan?"
                  onConfirm={() => {
                    this.deletePlanDetails({_id: record._id})
                  }}
                  okText="Yes"
                  cancelText="No">
                  <Button
                    className={styles.btn}
                    shape="circle"
                    icon="delete"
                  />
                </Popconfirm>
              </Tooltip>
            </RightsWrapper>
          </React.Fragment>
        )
      }
    ]
    return (
      <PageHeaderWrapper title={` Plan Details `}>
        <Card bordered={true}>
          <Tabs onChange={this.callback} type="card" activeKey={this.state.activeTab}>
            <TabPane tab={`All Plans`} key={0}>
              <h2>{`Total : ${this.state.total}`}</h2>
              <TableComp
                ref={this.table}
                columns={columns}
                apiRequest={this.apiRequest}
                extraProps={{scroll: {x: 900}}}
                pagination={{
                  showSizeChanger: true,
                  defaultPageSize: 50,
                  pageSizeOptions: ['10', '20', '50', '100', '1000']
                }}
              />
            </TabPane>
            
            <TabPane tab={(id?'Edit':'Add') + ' Plan Detail'} key={1}>
              <Form onSubmit={this.handleSubmit} style={{marginTop: 8}}>
                <GetAllFormFields
                  inputSchema={inputTypes}
                  refresh={this.refreshFxn}
                  getFieldDecorator={getFieldDecorator}
                />
                <Button
                  type=""
                  htmlType="submit"
                  style={{
                    marginBottom: 10,
                    marginLeft: '33%',
                    backgroundColor: 'green',
                    color: 'white'
                  }}
                  loading={this.props.loading}>
                  SAVE
                </Button>
                <Button
                  type="primary"
                  style={{marginBottom: 10, marginLeft: '1%'}}
                  loading={this.props.loading}
                  onClick={() => {
                    this.props.form.resetFields()
                  }}>
                  RESET
                </Button>
              </Form>
            </TabPane>
          </Tabs>
        </Card>
      </PageHeaderWrapper>
    );
  }
}

export default AllPlans
